
/* 外部Blogフィード表示 */
(function(h){var f="https://ac-web.api.everforth.com/capi";var c={limit:"2"};var d=["apikey","limit","start","brands","tags","used_by","using_to_product_number"];var e=["src","href","alt","title"];var g="ef-";h.ef_ajax=function(j,i){i.url=f+"/"+j;i.dataType="jsonp";h.ajax(i)};h.fn.ef=function(l,m){if(this.length){var k=jQuery(this);var j=jQuery.extend(true,{},c);for(a in m){j[a]=m[a]}d.forEach(function(n){var o=k.attr(g+n);if(o){j[n]=o}});var i=h("."+g+"item",k);if(i){b(l,j,i)}}return this};function b(k,j,i){i.hide();h.ajax({url:f+"/"+k,data:j,dataType:"jsonp",success:function(m){var l=m.data;l.forEach(function(o){var p=i.clone();p.show();for(attr in o){if(p.hasClass(g+attr)){p.text(o[attr])}e.forEach(function(q){if(p.hasClass(g+attr+"-"+q)){p.attr(q,o[attr])}});h("."+g+attr,p).text(o[attr]);e.forEach(function(q){if(q==="src"){h("."+g+attr+"-"+q,p).attr("style","background-image:url("+o[attr]+");")}else{h("."+g+attr+"-"+q,p).attr(q,o[attr])}});e.forEach(function(q){h("."+g+"url-"+q,p).attr(q,"https://studioatao-blog.jp"+o.blog_path+"/"+o.shortid)})}var n=function(q){if(q){for(attr in o){if(o[attr]){q=q.split("{{"+attr+"}}").join(o[attr])}}}return q};if(p.hasClass(g+"template")){p.html(function(q,r){return n(r)})}e.forEach(function(q){if(p.hasClass(g+"template-"+q)){p.attr(q,n(p.attr(q)))}});h("."+g+"template",p).html(function(q,r){return n(r)});e.forEach(function(q){h("."+g+"template-"+q,p).each(function(){h(this).attr(q,n(h(this).attr(q)))})});p.insertBefore(i)});i.remove()}})}})(jQuery);jQuery(function(){jQuery(".ef-productclasses").ef("productclass");jQuery(".ef-shops").ef("shop");jQuery(".ef-snaps").ef("snap");jQuery(".ef-blogs").ef("blog");jQuery(".ef-news").ef("news")});

$(window).load(function(){
  if(!($('.articlebox-blog-external .ef-blogs li').size())){
    $('.product--blog').remove();
  }
});


/* PCメガメニュー */
jQuery(function($){
    
  $('#site-header .header-bottom-pc .h-navi ul li').hover(function() {    
    $(this).children('.megamenu').addClass('open');
  }, function() { 
    $(this).children('.megamenu').removeClass('open');
  });

  
});



/* ヘッダー_トグルメニュー */
jQuery(function($){
  $(document).ready(function() {
    $('.header-bottom-sp .h-toggle').click(function() {      
      if($(this).hasClass('active') == true){
        $(this).removeClass('active');
        $('.header-bottom-sp .toggle-overlay').fadeOut();
        $('.header-bottom-sp .toggle-menu').fadeOut();  
      }else{
        $(this).addClass('active');
        $('.header-bottom-sp .toggle-overlay').fadeIn();
        $('.header-bottom-sp .toggle-menu').fadeIn();
      }
    });
    $(".header-bottom-sp .toggle-menu .close , .header-bottom-sp .toggle-overlay").click(function() {      
      $('.header-bottom-sp .h-toggle').removeClass('active');
      $('.header-bottom-sp .toggle-overlay').fadeOut();
      $('.header-bottom-sp .toggle-menu').fadeOut();
    });
  });
});

/* ヘッダー_トグルサーチ */
jQuery(function($){
    $(document).ready(function() {
      $('.header-bottom-sp .h-link .search').click(function() {      
        if($(this).hasClass('active') == true){
          $(this).removeClass('active');
          $('.header-bottom-sp .toggle-overlay').fadeOut();
          $('.header-bottom-sp .toggle-search').fadeOut();  
        }else{
          $(this).addClass('active');
          $('.header-bottom-sp .toggle-overlay').fadeIn();
          $('.header-bottom-sp .toggle-search').fadeIn();
        }
      });
      $(".header-bottom-sp .toggle-search .close , .header-bottom-sp .toggle-overlay").click(function() {        
        $('.header-bottom-sp .h-link .search').removeClass('active');
        $('.header-bottom-sp .toggle-overlay').fadeOut();
        $('.header-bottom-sp .toggle-search').fadeOut();
      });
    });
  });


/* グローバルナビゲーション_アコーディオン */
$(function(){    
    $(".articlebox-navi-menu .item:not(.item-w) .title").on("click", function() {
        $(this).toggleClass('open');
        $(this).next().slideToggle();
    });
    $(".articlebox-navi-menu .item-w .title").on("click", function() {
        $(this).toggleClass('open');
        $(this).nextAll('ul').slideToggle();
    });
});


/* ご利用ガイドページ_アコーディオン */
$(function(){    
  $(".page-guide .mokuji-box .item .tit").on("click", function() {
      $(this).toggleClass('open');
      $(this).next().slideToggle();
  });  
});

/* FAQページ_アコーディオン */
$(function(){    
  $(".page-faq .qa-block .qa-list .q-txt").on("click", function() {
      $(this).toggleClass('open');
      $(this).next().slideToggle();
  });  
});




/*　並び替えPOPUP */

function popupSort() {
  var popup = document.getElementById('js-popup-sort');
  if(!popup) return;

  var blackBg = document.getElementById('js-black-bg');

  var blackBg = document.getElementById('js-black-bg');
  var closeBtn = document.getElementById('js-close-btn');
  var showBtn = document.getElementById('js-show-popup');

  closePopUp(blackBg);
  closePopUp(closeBtn);
  closePopUp(showBtn);
  function closePopUp(elem) {
    if(!elem) return;
    elem.addEventListener('click', function() {
      popup.classList.toggle('is-show');
    });
  }
}
popupSort();
